import { CommonModule, DatePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { ClipboardService } from 'ngx-clipboard';
import { Subscription } from 'rxjs';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ApiService } from '../api.service';
import { SharedService } from '../shared.service';
import { ChatSupportService } from '../chat-support.service';
import { SendSmsComponent } from '../send-sms/send-sms.component';
import { CsrRequestModalComponent } from '../csr-request-modal/csr-request-modal.component';
import { localStorageService } from '../localstorage.service';
import { SocketsService } from '../socket/socket.service';

@Component({
  selector: 'app-chat-support',
  templateUrl: './chat-support.component.html',
  styleUrls: ['./chat-support.component.scss'],
})
export class ChatSupportComponent implements OnInit {
  hideFieldsForOthers: any = false;
  createTicketInProgress: any = false;
  recentchatData: any;
  userdataStats: any;
  shimmer: boolean = false;
  userId: any;
  activeUserId: number | null = null; // Track the active user ID
  user_status: any = 'Offline';
  sub: any;
  sub2: any;
  userData: any;
  timezoneName: any = localStorage.getItem('timezoneName');
  timezone: any = localStorage.getItem('timezone');
  paymentLink: any;
  @ViewChild('genratePaymentLinkModal') public genratePaymentLinkModal: any;
  @ViewChild('sendNotificationModal') public sendNotificationModal: any;
  @ViewChild('changeAssigne') public changeAssigne: any;
  sendEmailValue: any;
  sendSmsValue: any;
  isAuthenticate: any;
  subPayLink: boolean = false;
  boosterPayLink: boolean = false;
  dial_code: any = '+1';
  phone_number: any;
  email: any;
  linkExpireTime: any;
  readChatShow: boolean = false;
  selectedPaymentType = -1;
  paymentTypeArray: any = [
    { text: 'Select Subscription Type', id: -1 },
    // { text: 'Dispute', id: 1 },
    { text: 'Subscription (Monthly/Yearly)', id: 4 },
    { text: 'Monthly Subscription', id: 2 },
    { text: 'Yearly Subscription', id: 3 },
    { text: 'Upgrade Subscription', id: 5 },
  ];

  chatTypeArray: any = [
    { text: 'Your inbox', chat_type: 3, new_msg_count: 0 },
    { text: 'Unassigned Chats', chat_type: 2, new_msg_count: 0 },
    { text: 'All Chats', chat_type: 1, new_msg_count: 0 },
  ];

  chat_type: any = 1;
  read_type: any = 1;
  current_chat_type: any = 'Your inbox';
  // Chatbot Variables
  @Output() refreshTicket: any = new EventEmitter();
  @ViewChild('updateTicket') public updateTicket: any;
  @ViewChild('previewImageMeModal') public previewImageMeModal: any;
  @ViewChild('uploadAttachment', { static: false }) uploadAttachment: any;
  @ViewChild('textareaFocused', { static: false }) textareaFocused: any;
  @ViewChild('scrollMe') private myScrollContainer: any;
  @ViewChild('ssnModal') ssnModal: any;
  @ViewChild('show_filters') public show_filters: any;
  @ViewChild('viewDocModal') public viewDocModal: any;
  @ViewChild('assignToMeModal') public assignToMeModal: any;
  @ViewChild('chatWithUserModal') public chatWithUserModal: any;
  @ViewChild('adminGroupChatDataModal') public adminGroupChatDataModal: any;
  adminData: any;
  is_first_msg: any = false;
  activeList: any = 1;
  ticketList: any = [];
  selfTickets: any = [];
  current_admin: any;
  active_chat: any;
  enableChat: any = false;
  initiatedSocket: boolean = false;
  disableInput: boolean = false;
  public userUpdatedStatus = 'Away';
  chat_message: any = '';
  static_message: any = 'You have an important notification from recuvery.';
  static_message_es: any = 'Tiene una notificación importante del prestamista.';
  public file: any = {};
  messages: any = [];
  filesArr: any = [];
  preview_data: any = [];
  animationElm: boolean = false;
  checkSupportMsgStatus: any = true;
  scrollPosition: any = 0;
  old_height: any = 0;
  notification_type: any = 1;
  update_status: string = '';
  note: any = '';
  dynamic_msg: any = '';
  initChat: any;
  userReply: any = '';
  booster_purchased: any = false;
  subscription: any;
  subscription2: any;
  unreadData: any;
  UserDetailSelectedTab: number = 0;
  userDetailsData: any;
  showSSN: boolean = false;
  _ssnData: any;
  ssnShowType: any;
  ssnForm: any;
  show: boolean = false;
  chat_status: any = 1;
  user_status_filter: any = 1;
  userType: any = 1;
  start_date: any = new Date(2023, 9, 1);
  end_date: any = new Date();
  bsConfig = {
    showWeekNumbers: false,
    dateInputFormat: 'MM/DD/YYYY',
    selectFromOtherMonth: true,
  };
  search: any;
  docList: any;
  doc_url: any;
  offset: any = 0;
  limit: any = 50;
  modalRef?: BsModalRef;
  mainData: any = {};
  new_data_length: any = 0;
  show_unread_msg: boolean = true;
  stop_msg_read: boolean = false;
  showAssignModel: boolean = false;
  sub1: any;
  selected_user_id: any;
  is_dummy: string | number;
  group_chat_active_admins: any = [];
  group_chat_admins: any = [];
  adminGroupChatData: any = [];
  sub3: any;
  history_wp: any;
  notify: boolean = false;

  get timezoneVal(): any {
    return this.timezone;
  }
  @Input() set timezoneVal(val: any) {
    this.timezone = val;
  }
  subs: Subscription[] = [];
  public ticket_id: any;
  get ticketId(): string {
    return this.ticket_id;
  }
  chatEnabled = false;
  public ticket_status: any;
  get ticketStatus(): Number {
    return this.ticket_status;
  }
  @Input() set ticketStatus(val: Number) {
    if (val) {
      this.ticket_status = val;
    }
  }
  message_type: any = 1;
  public changeAssigneeForm!: FormGroup;
  retryEmitInterval: any = null;
  edit_wp_profile: boolean = false;
  showChatWindow: any = false;
  showChat: any = false;
  userTypeName: string = '';
  constructor(
    public socket: ChatSupportService,
    private clipboardApi: ClipboardService,
    private datePipe: DatePipe,
    private modalService: BsModalService,
    private router: Router,
    fb: FormBuilder,
    private _api: ApiService,
    public _shared: SharedService,
    private _local: localStorageService,
    private _socketService: SocketsService
  ) {
    this.ssnForm = fb.group({
      password: fb.control('', Validators.required),
      notes: fb.control('', Validators.required),
    });

    this.is_dummy = localStorage.getItem('is_dummy')
      ? parseInt(localStorage.getItem('is_dummy') || '1')
      : '0';
    this.changeAssigneeForm = fb.group({
      agent_id: [null],
      notes: ['', [Validators.required]],
    });

  }

  ngOnInit(): void {
    let profileData: any = this._local.customGetItem('admin_profile');
    console.log(profileData, 'profileData=-==');

    this.current_admin = profileData.admin_id;
    this.adminData = profileData;
    // this.subscription2 = this.service
    //   .getCurrentTimezone()
    //   .subscribe((value: any) => {
    //     this.timezone = value.timezone;
    //     this.timezoneName = value.name;
    //     // this.recentChat();
    //   });

    this.sub1 = this.socket.selected_chat.subscribe((dt: any) => {
      this.recentchatData = this.socket.recentchatData;
      console.log(dt, 'dt-t-t-t-t-');
      this.activeUserId = 0;
      this.active_chat = false;
      this.recentStats(dt);
    });

    this.userTypeName = this._socketService.panel_type == 1 ? 'doctor' : this._socketService.panel_type == 2 ? 'patient' : ''; 
  }

  ngAfterViewChecked() {
    if (this.myScrollContainer && this.myScrollContainer.nativeElement) {
      if (
        this.old_height != this.myScrollContainer.nativeElement.scrollHeight
      ) {
        this.old_height = this.myScrollContainer.nativeElement.scrollHeight;
        this.scrollToElement();
      }
    }
  }

  scrollToElement(): void {
    this.myScrollContainer.nativeElement.scroll({
      top: this.myScrollContainer.nativeElement.scrollHeight,
      left: 0,
      behavior: 'smooth',
    });
  }

  @HostListener('window:scroll', ['$event']) // for window scroll events
  onScroll(event: any) {
    if (this.myScrollContainer && this.myScrollContainer.nativeElement) {
      const scrollElement = this.myScrollContainer.nativeElement;
      if (scrollElement.scrollTop > this.scrollPosition) {
        this.scrollPosition = scrollElement.scrollTop;
        scrollElement.classList.remove('scroll-visible');
      } else if (scrollElement.scrollTop < this.scrollPosition - 100) {
        scrollElement.classList.add('scroll-visible');
      } else {
        scrollElement.classList.remove('scroll-visible');
      }
    }
  }

  recentStats(data: any) {
    console.log(data, 'datatatata---');
    //New code
    if (data) {
      this.ticket_status = data.ticket_status;
      this.ticket_id = data.req_id;

      //New socket
      this.socket.supportConnected(
        data.admin_name,
        this.current_admin,
        this.socket.alreadyConnectedArr.includes(data.req_id)
          ? 'admin_connected_back'
          : 'admin_assigned',
        this.active_chat?.req_id
      );
      // this.socket.getAdminGroupChatData(this.ticket_id);
    }

    if (data.group_chat_active_admins) {
      this.group_chat_active_admins = JSON.parse(data.group_chat_active_admins);
    }
    if (data.group_chat_admins) {
      this.group_chat_admins = JSON.parse(data.group_chat_admins);
    }
    // this.chatWithUser();

    this.userReply = '';
    this.enableChat = false;
    if (this.activeUserId === data[this.userTypeName + '_id'] ) {
      return;
    }
    this.activeUserId = data[this.userTypeName + '_id'];
    this.userData = data;
    this.handleEmits();
    this.openChat(data);

    if(this._socketService.panel_type == 1) {
      let data = {
        doctor_id: this.activeUserId,
      };
      this._api
        .api(data, 'business/doctor_info', 'get')
        .subscribe((data: any) => { 
          if(data.is_error == 0) {
            this.userDetailsData = data.doctor_profile[0];
          } else {
            this._shared.customPopups(data.msg,1);
          }          
      });
    }
  }

  // ChatbotF Functions Begins
  initiateSockets(): void {
    this.messages = [];
    this.subs.push(
      this.socket.clientMessage.subscribe((message) => {
        if (message && message.ticketId == this.ticket_id) {
          if (this.ticket_status == 2) {
            this.refreshTicket.emit(true);
          }
          if (message.attachments && typeof message.attachments === 'string') {
            message.attachments = JSON.parse(message.attachments);
            message.attachments.map(async () => {});
          }
          this.messages.push(message);
          // this.service.playNotificationSound();
          const incomingDraftMessageIndex = this.messages.findIndex(
            (item: any) => item['type'] === 'incoming_draft'
          );
          if (incomingDraftMessageIndex >= 0) {
            this.messages.splice(incomingDraftMessageIndex, 1);
          }

          if (this.show_unread_msg) {
            let index = this.messages.findIndex((dt: any) => dt.msg_type == 3);
            if (index != -1) {
              this.messages[index].count++;
            }
          }
        }
      })
    );

    this.subs.push(
      this.socket.clientConnected.subscribe((user_email) => {
        const check_ticket_user = this.messages.filter(
          (msg: any) => msg.from_email === user_email
        );
        if (check_ticket_user && check_ticket_user.length) {
          this.chatEnabled = true;
        }
      })
    );

    this.subs.push(
      this.socket.clientDisconnected.subscribe((user_email) => {
        const check_ticket_user = this.messages.filter(
          (msg: any) => msg.from_email === user_email
        );
        if (check_ticket_user && check_ticket_user.length) {
          this.chatEnabled = false;
        }
      })
    );

    this.subs.push(
      this.socket.custDraftMessage.subscribe((msg) => {
        if (msg && msg.ticketId == this.ticket_id) {
          if (msg && msg.type == 'incoming_draft') {
            if (msg.typingAnimation == true) {
              const index = this.messages.findIndex(
                (item: any) => item['type'] === 'incoming_draft'
              );
              if (msg.message && index < 0) {
                this.messages.push(msg);
              } else if (msg.message && index >= 0) {
                this.messages[index] = msg;
              } else if (!msg.message && index >= 0) {
                this.messages.splice(index, 1);
              }
              this.animationElm = true;
            } else {
              this.animationElm = false;
            }
          }
        }
      })
    );

    this.subs.push(
      this.socket.userActionMsg.subscribe((data) => {
        if (data.ticket_id == this.ticket_id) {
          this.userReply = data.res_msg;
        }
      })
    );

    this.socket.supportMessageSub.subscribe((res: any) => {
      if (res) {
        if (res.attachments && res.attachments.length > 0) {
          let ind = this.filesArr.some((item: any) =>
            item.file_name.includes(res.attachments[0].file_name)
          );
          if (!ind) {
            this.filesArr.push(res.attachments[0]);
          }
        }
        if (res.admin_id && res.admin_id != this.adminData.admin_id) {
          this.messages.push({
            type: 'incoming',
            message_type: 'normal',
            html: res.message.trim(),
            attachments: res.attachments,
            created: new Date(),
            agent_full_name: res.agent_name,
            agent_name: res.agent_name
              .split(' ')
              .reduce(
                (a: any, b: any) =>
                  a.charAt(0).toUpperCase() + b.charAt(0).toUpperCase(),
                ''
              ),
            admin_name: res.agent_name,
            msg_time: new Date(),
            text: res.message.trim(),
            other_admin_message: `${
              res.agent_name ? res.agent_name : ''
            } (Recuvery Support Team)`,
            admin_image: `https://testcommon.recuvery.com/recuveryfavicon.svg`,
          });
        }
      }
    });

    // Updating User Status
    this.socket.getUserUpdatedStatus.subscribe((data) => {
      if (data) {
        this.userUpdatedStatus = data.user_status
          ? data.user_status
          : data.userStatus;
      }
    });

    if (this.checkSupportMsgStatus) {
      this.socket.readMessage.subscribe((res) => {
        this.checkSupportMsgStatus = false;
        if (
          res.messages_read &&
          res.ticketId == (this.ticketId || this.ticket_id)
        ) {
          this.messages.map((elem: any) => {
            if (elem.msg_type != 1) {
              elem['readClass'] = 1;
            }
          });
        }
        setTimeout(() => {
          this.checkSupportMsgStatus = true;
        }, 3000);
      });
    }

    this.socket.adminChatRefresh.subscribe((data) => {
      if (data.ticketId) {
        data['update_counter'] = 1;
        // this.changeOrder(data);
        this.socket.changeOrder.emit(data);
      }
    });

    this.socket.newTicketCreation.subscribe((data) => {
      console.log(this.recentchatData, 'this.recentchatData---');

      if (data.req_id) {
        let index;

        if (this.recentchatData && this.recentchatData.length > 0) {
          index = this.recentchatData.findIndex(
            (elem: any) => elem.req_id == data.req_id
          );
        }

        console.log(index, 'index---');

        if (index != -1) {
          if (this.recentchatData[index].ticket_status != data.ticket_status) {
            this.recentchatData[index].ticket_status = data.ticket_status;
          }

          if (data.assigned_id == this.current_admin) {
            let selectedObject = this.recentchatData.splice(index, 1)[0];
            this.recentchatData.unshift(selectedObject);
          } else {
            this.recentchatData.push(data);
          }
        } else {
          if (data.assigned_id == this.current_admin) {
            this.recentchatData.unshift(data);
          }
        }
      }
    });

    this.socket.ticketStatusChangedEvent.subscribe((data) => {
      if (
        data.ticketId == this.ticket_id &&
        data.messageType === 'ticket_closed'
      ) {
        this.userUpdatedStatus = 'Away';
        this.ticket_status = 2;
        this.disableInput = true;
        this.is_first_msg = true;
        this.sub.unsubscribe();
        this.updateTicketStatusInList(this.active_chat.req_id, 2);
      }
    });

    this.socket.restartChatEvent.subscribe((data) => {
      console.log(this.ticket_id, 'this.ticket_id');

      if (data.ticketId == this.ticket_id) {
        this.restartChat();
      }
    });

    this.socket.getUpdatedTicketData.subscribe((data) => {
      if (data.ticketId == this.ticket_id) {
        if (
          data.admin_id != this.current_admin &&
          data.admin_name.includes(' (Me)')
        ) {
          data.admin_name = data.admin_name.replace(' (Me)', '');
        } else if (
          data.admin_id == this.current_admin &&
          !data.admin_name.includes(' (Me)')
        ) {
          data.admin_name = data.admin_name + ' (Me)';
        }
        this.active_chat.admin_name = data.admin_name;
      }
    });
  }

  restartChat() {
    this.enableChat = true;
    // this.ticket_id = undefined;
    // this.disableInput = false;
    // this.hideFieldsForOthers = false;
    this.ticket_status = 0;
  }

  updateTicketStatus(status: any) {
    this.update_status == 'resolved' ? 2 : 4;
    const statusValue = this.update_status == 'resolved' ? 2 : 4;
    let body = {
      new_status: status.toString(),
      followup_date: this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
      note: this.note,
      req_id: this.active_chat.req_id,
      admin_id: this.current_admin ? this.current_admin : undefined,
    };
    this._api
      .api(body, `chatbot/update_reassign_callback`, 'post')
      .subscribe((res) => {
        if (res.is_error == 0) {
          this.note = '';
          // this.userUpdatedStatus = 'Away';
          this.ticket_status = 2;
          this.disableInput = true;
          this.is_first_msg = true;
          this.sub.unsubscribe();
          if (status == statusValue) {
            // this.socket.getUserUpdatedStatus.next({
            //   userStatus: 'Offline',
            //   ticketId: this.ticket_id,
            // });
            if (this.showChatWindow) {
              this.showChatWindow = false;
              this.showChat = false;
              this.updateTicket.hide();
            }
          }
          this.update_status = '';
          this.socket.ticketStatusChanged('resolved', {
            ticketId: this.ticketId,
            message: 'Chat Ended',
          });
          // this.updateTicketStatusInList(this.active_chat.req_id, 2);
        } else {
          this._shared.customPopups(res.msg, 1);
        }
        this.updateTicket.hide();
      });
  }

  createTicket(key: number) {
    console.log(this.active_chat, 'this.active_chat---');

    this.createTicketInProgress = true;
    let body = {
      name:
        this.active_chat.name && this.active_chat.name != null
          ? this.active_chat.name
          : undefined,
      email:
        this.active_chat.email && this.active_chat.email != null
          ? this.active_chat.email
          : undefined,
      phone:
        this.active_chat.mobile && this.active_chat.mobile != null
          ? this.active_chat.mobile
          : undefined,
      subject:
        this.notification_type == 1
          ? this.static_message
          : this.notification_type == 3
          ? this.static_message_es
          : this.dynamic_msg,
      message:
        this.notification_type == 1
          ? this.static_message
          : this.notification_type == 3
          ? this.static_message_es
          : this.dynamic_msg,
      contact_mode: 'chat',
      created_from: 'chat',
      chatbot_ticket_mode: '1',
      country_id: '2',
      user_id: this.getUserId(),
      chat_initiated_by: 1,
      visitor_id: this.active_chat?.wp_query_id?.toString(),
      user_type: this._socketService.panel_type,
    };

    if (body['subject'] == '') {
      body['subject'] =
        'You have an important message regarding your credit repair';
      body['message'] =
        'You have an important message regarding your credit repair';
    }

    this._api.api(body, `chatbot/create_ticket_v3`, 'post').subscribe((res) => {
      if (res.is_error == 0) {
        this.is_first_msg = false;
        this.createTicketInProgress = false;
        this.ticket_id = res.data.ticket_id;
        this.ticket_status = res.data.ticket_status;
        // this.updateTicketStatusInList(this.ticket_id, this.ticket_status);
        this.chatWithUser();
        if (key == 1) {
          this._api
            .api(body, `chatbot/send_user_notification`, 'post')
            .subscribe((res) => {
              if (res.is_error == 0) {
                this.notify = true;
                this.sendNotificationModal.hide();
                // this.dynamic_msg = "";
                this.sendMessage(null, false);
              } else {
                this._shared.customPopups(res.msg, res.is_error);
              }
            });
        } else {
          this.sendMessage(null, 0);
        }
      }
    });
  }

  async sendMessage(event?: any, is_first_msg?: any) {
    if (
      (event instanceof KeyboardEvent &&
        event.key === 'Enter' &&
        event.ctrlKey) ||
      (event instanceof PointerEvent && event.pointerType === 'mouse') ||
      this.notify
    ) {
    } else {
      return; // Return without hitting API
    }

    console.log(this.is_first_msg, 'this.is_first_msg---');

    if (this.is_first_msg) {
      if (this.createTicketInProgress) {
        return;
      }
      this.createTicket(0);
      return;
    }
    this.notify = false;
    // let serDetails: any = localStorage.getItem('profileData') || null;

    let serDetails = this.adminData;
    if (event) {
      event.preventDefault();
    }

    if ((this.chat_message && this.chat_message.trim()) || this.file.path) {
      const attachment_data: any = [
        {
          file_url: this.file.path,
          file_name: this.file.name,
        },
      ];
      if (this.file.path) {
        await this._shared
          .getImageType(this.file.path)
          .then((image_type: any) => {
            attachment_data[0]['file_type'] = image_type;
          });
      }

      let html_msg = this._shared.getURLFromString(this.chat_message);
      const message_index = this.messages.length;
      const incoming_draft_index = this.messages.findIndex(
        (ele: any) => ele.type === 'incoming_draft'
      );
      let incoming_draft_message = '';
      if (incoming_draft_index >= 0) {
        incoming_draft_message = this.messages[incoming_draft_index];
        this.messages.pop();
      }

      if (this.message_type != 1) {
        html_msg =
          (this.message_type && this.message_type == 2
            ? 'Notification Type - Generic || '
            : this.message_type && this.message_type == 3
            ? 'Notification Type - Custom || '
            : '') + html_msg;
      }

      let last_index = this.messages.length - 1;
      if(this.messages[last_index].admin_id == 0) {
        this.assignToMe(1);
      }

      this.messages.push({
        type: 'outgoing',
        html: html_msg.trim(),
        attachments: attachment_data,
        created: new Date(),
        agent_full_name: serDetails['admin_name'],
        agent_name: serDetails['admin_name']
          .split(' ')
          .reduce(
            (a: any, b: any) =>
              a.charAt(0).toUpperCase() + b.charAt(0).toUpperCase(),
            ''
          ),
        show_progress: true,
        message_index: message_index,
        admin_name: serDetails['admin_name'],
        msg_time: new Date(),
        text: html_msg.trim(),
      });

      const chat_data = {
        ticketId: this.ticket_id,
        message: this.chat_message.trim(),
        message_file: this.file.path,
        fileName: this.file.name,
        newFlow: true,
        isAdminMessage: '1',
        agent_name: serDetails['admin_name'],
        user_id: this.activeUserId,
        is_first_msg: is_first_msg ? is_first_msg : 0,
        bottom_txt: 'Recuvery Expert',
        msg_type: 1,
        created: new Date(),
        admin_image: 'https://testcommon.recuvery.com/recuveryfavicon.svg',
        messageType:
          this.message_type && this.message_type == 2
            ? 'notification_type_generic'
            : this.message_type && this.message_type == 3
            ? 'notification_type_custom'
            : undefined,
        is_dummy: this.is_dummy,
      };
      console.log(chat_data, 'chat_datachat_datachat_data');

      this.message_type = 1;
      this.chat_message = '';
      this.file = {};
      this.show_unread_msg = false;
      this.socket.supportMessage(chat_data);
      if (incoming_draft_message) {
        this.messages[message_index - 1].show_progress = false;
        this.messages.push(incoming_draft_message);
      } else {
        this.messages[message_index].show_progress = false;
      }

      this.socket.changeOrder.emit({
        ticketId: this.ticket_id,
        message: chat_data.message,
      });
      // this.changeOrder({
      //   ticketId: this.ticket_id,
      //   message: chat_data.message,
      // });
    }
  }

  fileSelectionAlert(event: any) {
    this.uploadAttachment.nativeElement.click();
    this.textareaFocused.nativeElement.click();
  }

  handleEmits() {
    // let active_chat = this.recentchatData.filter(
    //   (elem) => elem.user_id == this.activeUserId
    // );
    if (!this.initiatedSocket) {
      this.initiatedSocket = !this.initiatedSocket;
      this.initiateSockets();
    }
    // this.openChat(active_chat[0]);
  }

  fileSelection(event: any): void {
    const reader: any = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      if (file && file.size > 4200000) {
        this._shared.customPopups('File size greater than 4MB', 1);
        return;
      }
      reader.readAsDataURL(file);
      reader.onload = async () => {
        this.file = {
          name: file.name,
          type: file.type,
          path: reader.result.toString(),
        };
        await this._shared
          .getImageType(this.file.path)
          .then((image_type: any) => {
            this.file['image_type'] = image_type;
          });
        if (!['jpeg', 'png', 'jpg', 'pdf'].includes(this.file['image_type'])) {
          this.file = {};
          this._shared.customPopups(
            'Only .png, .jpg, .jpeg and .pdf format allowed! ',
            2
          );
        }
      };
      setTimeout(() => {
        this.textareaFocused.nativeElement.focus();
      }, 100);
    }
  }

  msgTyping() {
    this.socket.msgTyping(this.ticketId, this.adminData);
    if (!this.stop_msg_read) {
      this.msgRead();
    }
  }

  msgRead() {
    if (!this.stop_msg_read) {
      this.socket.msgRead(this.ticketId);
    }
  }

  openSubPdf(file: any) {
    if (
      file &&
      file.file_url &&
      file.file_url.includes('https://common.lendee.com')
    ) {
      window.open(file.file_url, '_blank');
    } else {
      setTimeout(() => {
        let ind = this.filesArr.findIndex(
          (ele: any) => ele.file_name == file.file_name
        );
        window.open(this.filesArr[ind].file_url, '_blank');
      }, 1000);
    }
  }

  openPdf(file: any) {
    window.open(file.file_url, '_blank');
  }

  imagePreview(image: any) {
    let preview_data = [
      { image: image.file_url, description: image.file_name },
    ];
    this.preview_data = [
      { image: image.file_url, description: image.file_name },
    ];
    this.previewImageMeModal.show();
  }
  // Chatbot Functions Ends

  // recentChat(type?: any) {
  //   if (this.start_date > this.end_date) {
  //     this._shared.customPopups(
  //       'End date should be greater than start date',
  //       1
  //     );
  //     return;
  //   }

  //   if (type == 1) {
  //     this.offset += 50;
  //   }

  //   let body = {
  //     chat_type: this.chat_type, //1- All, 2- Unassigned, 3- Yours
  //     read_type: this.read_type, //1- All, 2- unread
  //     search_string: this.search,
  //     user_status: this.user_status_filter, //1- All, 2- Online, 3- Offline
  //     chat_status: this.chat_status, //1- All, 2- Active-Reopen, 3- Closed
  //     userType: this.userType, //1- All, 2- Pro User, 3- Free User,
  //     start_date: this.datePipe.transform(this.start_date, 'MM/dd/yyyy'),
  //     end_date: this.datePipe.transform(this.end_date, 'MM/dd/yyyy'),
  //     offset: this.offset,
  //     limit: this.limit,
  //   };

  //   this._api
  //     .api(body, `chatbot/chat_tickets_list_v2`, 'post')
  //     .subscribe((res: any) => {
  //       if (res.is_error == 0) {
  //         this.new_data_length = res.data.ticketList.length;
  //         if (type == 1) {
  //           this.recentchatData = [
  //             ...this.recentchatData,
  //             ...res.data.ticketList,
  //           ];
  //         } else {
  //           this.recentchatData = res.data.ticketList;
  //           this.unreadData = res.data;
  //           this.userData = this.recentchatData[0];
  //           this.recentStats(this.recentchatData[0]);
  //         }
  //       } else {
  //         if (!type) {
  //           this.recentchatData = [];
  //           this.messages = [];
  //           this.active_chat = false;
  //           this.userdataStats = '';
  //           this.booster_purchased = '';
  //           this.userDetailsData = '';
  //           this.docList = [];
  //           this.activeUserId = 0;
  //         }
  //       }
  //       this.show_filters.hide();
  //     });
  // }

  async sendNotification() {
    let body = {
      user_id: this.activeUserId,
      message:
        this.notification_type == 1
          ? this.static_message
          : this.notification_type == 3
          ? this.static_message_es
          : this.dynamic_msg,
    };

    let txt = '';

    // if(this.notification_type == 1) {
    //   txt = "Notification Type - Generic || "
    // } else {
    //   txt = "Notification Type - Custom || "
    // }

    this.chat_message = txt.concat(body.message);

    if (this.messages.length == 0 || this.ticket_status == 2) {
      await this.createTicket(1);
    } else {
      this._api
        .api(body, `chatbot/send_user_notification`, 'post')
        .subscribe((res) => {
          if (res.is_error == 0) {
            this.notify = true;
            this.sendNotificationModal.hide();
            // this.dynamic_msg = "";
            this.is_first_msg = false;
            this.sendMessage(null, false);
          } else {
            this._shared.customPopups(res.msg, res.is_error);
          }
        });
    }
  }

  setTabState(tabId: number): void {
    this.UserDetailSelectedTab = tabId;
  }

  password() {
    this.show = !this.show;
  }

  showCompleteSSN() {
    let body = {
      password: this.ssnForm?.value?.password,
      user_id: this.activeUserId,
      note: this.ssnForm?.value?.notes,
    };
    this._api.api(body, `user/check_ssn`, 'post').subscribe((res) => {
      if (res.is_error == 0) {
        this._ssnData = res?.data?.ssn;
        this.ssnForm.reset();
        this.ssnModal.hide();
        if (this.ssnShowType == 1) {
          this.showSSN = true;
        } else if (this._ssnData && this.ssnShowType == 2) {
          // this.showSSNEditedField = true;
        }
      } else {
        this._shared.customPopups(res.msg, res.is_error);
      }
    });
  }

  userDocs() {
    if (this.activeUserId != 0) {
      let data = {
        user_id: this.activeUserId,
      };
      this._api
        .api(data, 'user/get_user_docs_v2', 'post')
        .subscribe((res: any) => {
          if (res.is_error == 0) {
            this.docList = res?.data;
          } else {
            this._shared.customPopups(res.msg, res.is_error);
          }
        });
    }
  }

  export_chat() {
    this._api
      .downloadApi(
        { ticket_id: this.active_chat?.req_id.toString() },
        'chatbot/download_zip',
        0
      )
      .subscribe((data: any) => {
        console.log(data);
      });
  }

  showCsrRequest() {
    this.mainData.assign_type = 1;
    let initialState = {
      id: this.activeUserId,
      data: this.mainData,
    };
    let config = {
      backdrop: true,
      ignoreBackdropClick: true,
    };
    this.modalRef = this.modalService.show(CsrRequestModalComponent, {
      initialState: initialState,
      backdrop: config.backdrop,
      ignoreBackdropClick: config.ignoreBackdropClick,
      class: 'modal-lg',
    });
  }

  openSMSModal() {
    let userId = this.activeUserId;
    let first_name = this.userDetailsData?.name;
    // let last_name = this.userDetailsData?.last_name;
    let mobile = this.userDetailsData?.mobile;
    let dial_code = this.userDetailsData?.dial_code;
    let initialState = {
      userId,
      first_name,
      // last_name,
      mobile,
      dial_code,
    };
    let config = {
      backdrop: true,
      ignoreBackdropClick: true,
    };
    this.modalRef = this.modalService.show(SendSmsComponent, {
      initialState: initialState,
      backdrop: config.backdrop,
      ignoreBackdropClick: config.ignoreBackdropClick,
      class: 'modal-lg',
    });
  }

  assignToMe(key: any) {
    let body = {
      ticket_note: 'Admin assigned this ticket to himself.',
      self_assigned_ticket: true,
      admin_id: this.adminData.admin_id,
      ticket_id: this.active_chat.req_id,
      user_type: this._socketService.panel_type,
    };
    this._api
      .api(body, `chatbot/assign_ticket_to_admin`, 'post')
      .subscribe((res: any) => {
        if (res.is_error == 0) {
          this.stop_msg_read = false;
          if (key == 2 && this.active_chat.assigned_id != this.current_admin) {
            this.socket.message_open$.next({ key: 'update_count_inbox' });
          }

          if (key == 1) {
            this.socket.message_open$.next({ key: 'update_count' });
          }
          this.active_chat['assigned_id'] = this.adminData.admin_id;
          this.active_chat['first_assigned_id'] = this.adminData.admin_id;
          this.active_chat['admin_name'] = this.adminData.admin_name;

          //New socket
          // let admin_name = this.socket.agent_list.filter((elem: any) => elem.value == this.adminData.admin_id)[0].label;
          this.socket.updateTicketData({
            ticketId: this.ticket_id,
            admin_id: this.adminData.admin_id,
            admin_name: this.adminData.admin_name,
          });
          this.socket.restartChat(this.ticket_id);
          this.chatWithUser();
          this.restartChat();
          if (!this.ticket_id) {
            this.is_first_msg = true;
          }
          this.showAssignModel = false;
          this._shared.customPopups(res.msg, 0);
        }

        let ind = this.socket.alreadyConnectedArr.findIndex((ele: any) => {
          return ele == this.ticket_id;
        });

        if (ind != -1) {
          this.socket.alreadyConnectedArr.splice(ind, 1);
        }

        this.socket.getSupportChatData();
        this.assignToMeModal.hide();
      });
  }

  setRedeemOption(notification_type: any) {
    this.notification_type = notification_type;
    this.message_type =
      notification_type == 1 || notification_type == 3
        ? 2
        : notification_type == 2
        ? 3
        : 1;
    if (this.notification_type == 1 || this.notification_type == 3) {
      this.dynamic_msg = '';
    }
  }

  paymentLinkModalHide() {
    this.sendEmailValue = false;
    this.paymentLink = '';
    this.sendSmsValue = false;
    this.isAuthenticate = false;
    this.linkExpireTime = '';
    this.selectedPaymentType = -1;
    this.genratePaymentLinkModal.hide();
    this.phone_number = this.userData.mobile;
    this.dial_code = this.userData.dial_code;
    this.email = this.userData.email;
  }

  showGenratePaymentLinkModal(type: any) {
    this.phone_number = this.userData.mobile;
    this.dial_code = this.userData.dial_code;
    this.email = this.userData.email;
    this.subPayLink = false;
    this.boosterPayLink = false;
    if (type == 1) {
      this.subPayLink = true;
    } else if (type == 2) {
      this.boosterPayLink = true;
    }
    this.genratePaymentLinkModal.show();
  }

  generatePaymentLink() {
    if (this.selectedPaymentType < 1 && this.subPayLink) {
      return this._shared.customPopups(
        'Please select payment type then continue',
        1
      );
    }
    let phone_number = this.userData.mobile;
    let dial_code = this.userData.dial_code;
    let email = this.userData.email;
    if (this.sendSmsValue) {
      if (this.phone_number) {
        phone_number = this.phone_number;
        dial_code = this.dial_code;
      }
      if (!dial_code.startsWith('+')) {
        dial_code = '+' + dial_code;
      }
      if (this.allowedDialCodesValidator(dial_code)?.invalidDialCode) {
        return this._shared.customPopups('Please select valid dial code', 1);
      } else if (phone_number.length != 10) {
        return this._shared.customPopups('Please enter valid mobile number', 1);
      }
    }
    if (this.sendEmailValue) {
      if (this.email) {
        email = this.email;
      }
      if (!email) {
        return this._shared.customPopups('Please enter valid email', 1);
      }
    }
    let body: any = {
      user_id: this.userData.user_id,
      payment_link_type: this.boosterPayLink ? 6 : this.selectedPaymentType,
      send_email: this.sendEmailValue ? 1 : 0,
      send_sms: this.sendSmsValue ? 1 : 0,
      is_authenticate: this.isAuthenticate ? 1 : 0,
      //mobile_number:phone_number,
      // dial_code:dial_code,
      // email:email
    };
    if (email) {
      body['email'] = email;
    }
    if (phone_number) {
      body['mobile_number'] = phone_number;
      body['dial_code'] = dial_code;
    }
    if (this.linkExpireTime) {
      body['expire_time'] = this.linkExpireTime;
    }
    this._api
      .api(body, `user/genrate_payment_link`, 'post')
      .subscribe((res) => {
        if (res.is_error == 0) {
          this.paymentLink = res.data.link;
          this._shared.customPopups(res.msg, res.is_error);
        } else {
          this.paymentLink = '';
          this._shared.customPopups(res.msg, res.is_error);
        }
      });
  }

  allowedDialCodesValidator(dial_code: any) {
    const validDialCodes = ['+1', '+91'];
    const value = dial_code;
    return validDialCodes.includes(value) ? null : { invalidDialCode: true };
  }

  copyText() {
    this.clipboardApi.copyFromContent(this.paymentLink);
    this._shared.customPopups('Content copied to clipboard', 0);
  }

  alertMe($event: any) {
    if ($event.tab.textLabel == 'Other Details') {
    }
  }

  redirect() {
    let userTypeName = this._socketService.panel_type == 1 ? 'business' : this._socketService.panel_type == 2 ? 'customers' : '';     
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/app/${userTypeName}/users/profile/${this._shared.encodeId(this.userData[this.userTypeName + '_id'])}`])
    );
    window.open(url, '_blank');
  }

  changeOrder(data: any) {
    let index = this.recentchatData.findIndex(
      (elem: any) =>
        elem.req_id == data.ticketId && elem.assigned_id == this.current_admin
    );
    if (index != -1) {
      let selectedObject = this.recentchatData.splice(index, 1)[0];
      selectedObject['note'] = data.message;
      if (data.update_counter == 1 && this.ticket_id != data.ticketId) {
        selectedObject['new_msg_count']++;
      }
      this.recentchatData.unshift(selectedObject);
    }

    if (data.key == 2) {
      this.recentchatData.unshift(this.recentchatData[index]);
    }
  }

  updateTicketStatusInList(ticket_id: any, ticket_status: any) {
    console.log(ticket_id, 'ticket_id---');
    console.log(ticket_status, 'ticket_status---');
    console.log(this.recentchatData, 'this.recentchatData.---');

    let index = this.recentchatData.findIndex(
      (elem: any) => elem.req_id == ticket_id
    );
    if (index != -1) {
      this.recentchatData[index]['ticket_status'] = ticket_status;
    }
  }

  openChat(chat: any) {
    console.log(chat, 'chat---');

    this.stop_msg_read = false;
    this.showChat = true;
    this.adminGroupChatData = [];

    if (chat.wp_query_id) {
      this.history_wp = chat;
    }

    if (
      this.showAssignModel == true &&
      chat.first_assigned_id == 0 &&
      chat.assigned_id == 0
    ) {
      if (this.active_chat) {
        this.ticket_id = this.active_chat.req_id;
      }
      this.assignToMeModal.show();
    } else {
      this.assignToMeModal.hide();
    }

    if (!this.active_chat?.req_id) {
      this.messages = [];
    }

    if (this.active_chat && this.active_chat?.req_id == chat?.req_id) {
      return;
    }
    this.active_chat = chat;
    this.socket.supportConnected(
      chat?.admin_name,
      this.current_admin,
      this.socket.alreadyConnectedArr.includes(chat?.req_id)
        ? 'admin_connected_back'
        : 'admin_assigned',
      this.active_chat?.req_id
    );

    this.sub = this.socket.adminChatHistory.subscribe((data: any) => {
      if (
        this.messages &&
        this.messages.length > 0 &&
        ((data.length == 1 && this.messages[0].user_id == data[0].user_id) ||
          (data.length >= 2 && this.messages[0].user_id == data[1].user_id))
      ) {
        return;
      }

      if (
        (data.length == 1 && this.active_chat.user_id != data[0].user_id) ||
        (data.length >= 2 && this.active_chat.user_id != data[1].user_id)
      ) {
        return;
      }

      let last_index = data && data.length > 0 ? data.length - 1 : -1;

      if (last_index == -1) {
        this.is_first_msg = true;
      } else {
        this.ticket_status = data[last_index].ticket_status;
      }

      if (
        data[last_index].assigned_id == 0 &&
        data[last_index].first_assigned_id == 0
      ) {
        this.stop_msg_read = true;
        this.showAssignModel = true;
        this._shared.stopNotificationSound();
        this.assignToMeModal.show();
      }
      this.messages = [];
      console.log(
        this.adminData.admin_id,
        'this.adminData.admin_idthis.adminData.admin_id'
      );

      data.forEach((elem: any) => {
        if (
          elem.message_type != 'ticket_closed' &&
          elem.admin_id != this.adminData.admin_id &&
          elem.msg_type != 3
        ) {
          elem['msg_type'] = 1;
        }
        this.messages.push({
          text: elem.text,
          user_name: elem.user_name,
          attachments: elem.attachments ? JSON.parse(elem.attachments) : [],
          isAdminMessage: elem.isAdminMessage,
          admin_name: elem.admin_name,
          admin_id: elem.assigned_id,
          created: new Date(elem.created),
          message_type: elem.message_type,
          msg_type: elem.msg_type,
          msg_time: elem.created,
          type:
            elem.msg_type == 1
              ? 'incoming'
              : elem.msg_type == 3
              ? 'unread_msg'
              : 'outgoing',
          show_progress: false,
          user_id: elem.user_id,
          readClass: elem.readClass,
          message_seen_at: elem.message_seen_at,
          count: elem.msg_type == 3 ? elem.count : 0,
          other_admin_message:
            elem.isAdminMessage == '1' &&
            this.adminData.admin_id &&
            elem.message_type != 'ticket_closed' &&
            elem.admin_id != this.adminData.admin_id
              ? `${
                  elem.chat_admin_name ? elem.chat_admin_name : ''
                } (Recuvery Support Team)`
              : '',
          admin_image:
            elem.isAdminMessage == '1' &&
            this.adminData.admin_id &&
            elem.message_type != 'ticket_closed' &&
            elem.admin_id != this.adminData.admin_id
              ? `https://testcommon.recuvery.com/recuveryfavicon.svg`
              : '',
        });
      });
    });

    this.show_unread_msg = true;

    console.log(this.recentchatData, 'this.recentchatData----');

    if (
      this.recentchatData != undefined &&
      this.recentchatData &&
      this.recentchatData.length > 0
    ) {
      let index = this.recentchatData.findIndex(
        (elem: any) =>
          elem.req_id == this.ticket_id &&
          elem.assigned_id == this.current_admin
      );
      if (index != -1) {
        if (this.recentchatData[index].new_msg_count > 0) {
          this.recentchatData[index].new_msg_count = 0;
        }
      }
    }

    this.sub3 = this.socket.adminGroupChatData.subscribe((data: any) => {
      if (this.group_chat_active_admins == data.group_chat_active_admins) {
        return;
      }
      this.adminGroupChatData = data.adminChatData;
      this.group_chat_active_admins = data.group_chat_active_admins;
      this.group_chat_admins = data.group_chat_admins;

      // //new code
      // if (this.group_chat_admins && this.group_chat_admins.length > 0) {
      //   console.log(this.group_chat_admins, this.current_admin, "************************************", this.group_chat_active_admins);
      //   if ((!this.group_chat_admins.includes(this.current_admin)) || (this.group_chat_admins.includes(this.current_admin) && (this.group_chat_active_admins && !this.group_chat_active_admins.includes(this.current_admin)))) {
      //     this.chatWithUser();
      //   }
      // }

      this.adminGroupChatData.map((elem: any) => {
        if (
          this.group_chat_active_admins &&
          this.group_chat_active_admins.includes(elem.admin_id)
        ) {
          elem['online'] = true;
        } else {
          elem['online'] = false;
        }
      });
    });
  }

  hideAssignModel() {
    this.assignToMeModal.hide();
    this.activeUserId = 0;
    // this.ticket_id = 0;
  }

  getInitials(name: string) {
    if (name) {
      const nameParts = name.trim().split(' ');
      if (nameParts.length >= 2) {
        // Take the first letter of the first and last name
        return nameParts[0][0] + nameParts[1][0];
      } else if (nameParts.length === 1) {
        // For a single name, take the first two letters
        return nameParts[0][0] + nameParts[0][1];
      }
    } else {
      return 'RC';
    }

    return false;
  }

  chatWithUser() {
    console.log(this.ticket_id, 'this.ticket_id--');

    if (!this.ticket_id) {
      return;
    }
    this._api
      .api(
        { ticket_id: this.ticket_id, admin_id: this.current_admin },
        `chatbot/admin_chat_with_user`,
        'post'
      )
      .subscribe((res) => {
        if (res.is_error == 0) {
          this.disableInput = false;
          this.socket.getAdminGroupChatData(this.ticket_id);
        } else {
          this._shared.customPopups(res.msg, 1);
        }
      });
  }

  updateTicketStatusV2(status: any, admin_id?: any) {
    let body = {
      new_status: status.toString(),
      followup_date: this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
      note: admin_id
        ? this.changeAssigneeForm.controls['notes'].value
        : this.note,
      req_id: this.ticket_id,
      admin_id: admin_id ? admin_id : this.current_admin,
    };
    this._api
      .api(body, `chatbot/update_reassign_callback`, 'post')
      .subscribe((res) => {
        if (res.is_error == 0) {
          this.note = '';
          if (status == 2) {
            this.socket.getUserUpdatedStatus.next({
              userStatus: 'Offline',
              ticketId: this.ticket_id,
            });
            this.userUpdatedStatus = 'Away';
          }
          this.update_status = '';
          this._shared.customPopups(res.msg, 0);
          let admin_name = this.socket.agent_list.filter(
            (elem: any) => elem.value == admin_id
          )[0].label;
          this.socket.updateTicketData({
            ticketId: this.ticket_id,
            admin_id: admin_id,
            admin_name: admin_name,
          });
        } else {
          this._shared.customPopups(res.msg, 1);
        }
        this.updateTicket.hide();
        this.changeAssigne.hide();
        this.changeAssigneeForm.reset();
      });
  }

  ngOnDestroy() {
    this.sub1.unsubscribe();
    this.adminGroupChatData = [];
    this.group_chat_admins = [];
    this.group_chat_active_admins = [];
  }

  getUserId() {
    return this._socketService.panel_type == 1 ? this.active_chat?.['doctor' + '_id']?.toString() : this._socketService.panel_type == 2 ? this.active_chat?.['patient' + '_id']?.toString() : this._socketService.panel_type == 3 ? this.active_chat?.['partner' + '_id']?.toString() : this._socketService.panel_type == 4 && this.active_chat?.['request' + '_id']?.toString();
  }
}
